import './index.less';
import classnames from 'classnames';
import { useState } from 'react';
import { useEffect } from 'react';
import { SelectedIcon } from 'components/Icons';

export type RevxCoverCardProps = {
  className?: string;
  children?: React.ReactNode;
  title?: string;
  size?: 'default' | 'small' | 'x-small';
  defaultChecked?: boolean;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
};

export const RevxCoverCard = (props: RevxCoverCardProps) => {
  const [checked, setChecked] = useState<boolean>(() => {
    if (props.checked !== undefined) {
      return props.checked;
    } else if (props.defaultChecked !== undefined) {
      return props.defaultChecked;
    } else {
      return false;
    }
  });

  useEffect(() => {
    if (props.checked !== undefined) {
      setChecked(props.checked);
    }
  }, [props.checked]);

  return (
    <div
      className={classnames(
        'revx-cover-card',
        'revx-cover-card-' + (props.size || 'default'),
        props.className,
        {
          checked: checked,
          none: !props.children,
        }
      )}
      onClick={() => {
        const newChecked = !checked;
        if (props.checked === undefined) {
          setChecked(newChecked);
        }

        if (props.onChange) {
          props.onChange(newChecked);
        }
      }}
    >
      {props.children && (
        <div className="revx-cover-card-content">{props.children}</div>
      )}
      <div className="revx-cover-card-title">{props.title}</div>
      {checked && <SelectedIcon className="revx-cover-card-selected-icon" />}
    </div>
  );
};
